<div class="container" [class.mobile]="isMobileVersion">
  @if (!isMobileVersion) {
    <div class="illustration">
      @if (illustration) {
        <img
          [src]="illustration"
          (error)="illustration !== fallbackIllustration && (illustration = fallbackIllustration)"
        />
      } @else {
        <ng-content select="[illustration]"></ng-content>
      }
    </div>
  }
  <div class="controls">
    <img [src]="logo" (click)="onLogoClick()" (error)="logo !== fallbackLogo && (logo = fallbackLogo)" />
    @if (showForgotPasswordView) {
      <ng-content select="[forgot-password]"></ng-content>
    } @else {
      <abc-authentication-login
        #abcLoginComponent
        (onNeedsPasswordChange)="needsPasswordChange = true"
        (onForgotPasswordClicked)="showForgotPasswordView = true"
        [showRegistration]="showRegistration"
        [showResetPassword]="showResetPassword"
        [useCustomLoader]="useCustomLoader"
        [twoFaIssuer]="twoFaIssuer"
      >
        <ng-content custom-loader select="[custom-loader]"></ng-content>
      </abc-authentication-login>
      @if (needsPasswordChange) {
        <abc-management-users-user-settings
          [allowUserNameChange]="false"
          (onPasswordChanged)="abcLoginComponent.rerouteLogin('')"
        >
        </abc-management-users-user-settings>
      }
    }
  </div>
</div>
